import { useEffect, useState } from "react";
import BuyButton from "@/components/books/BuyButton";

/**
 * StickyBuyBar — slim mobile-only purchase bar (Command 03 §16).
 * Appears after the visitor scrolls past the hero. Delegates the actual
 * purchase action to BuyButton so it uses the same Standard Checkout +
 * Orders API flow (with Payment Link fallback) as every other CTA.
 */
export default function StickyBuyBar({ product, label, source, testId, accentColor = "#F57F17", barClassName = "" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid={testId}
      className={`books-sticky-buy-bar fixed bottom-0 inset-x-0 z-40 md:hidden bg-white/95 backdrop-blur border-t px-4 pt-3 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      } ${barClassName || "border-[#E7DFCF]"}`}
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <div className="flex items-center justify-between gap-3 max-w-[1240px] mx-auto">
        <div className="flex items-baseline gap-2">
          <span className="text-[14px] text-[#9AA1AB] line-through" style={{ textDecorationColor: `${accentColor}B3` }}>{product.regular_price}</span>
          <span className="font-serif-d text-[24px] text-[#0D1B2A] leading-none">{product.price}</span>
        </div>
        <BuyButton
          product={product}
          label={label || "Buy Now"}
          source={source}
          testId={`${testId}-button`}
          accentColor={accentColor}
          className="[&>button]:px-6 [&>button]:py-3 [&_span]:hidden"
        />
      </div>
    </div>
  );
}
